import type { EmployeeSearchServiceQueryParams } from "@performyard/service-contracts";

import { getEmployeesSearchService } from "../../../api/services/defs/internal-api/employee-search-service";

export const employeeSearchServiceQuery = (params: Partial<EmployeeSearchServiceQueryParams> = {}) => ({
	queryKey: ["employee-search-service", params],
	queryFn: () => getEmployeesSearchService(params),
	meta: {
		errorMessage: "There was an error getting employee search service.",
	},
});
